import type { Theme } from '@mui/material';

export const styles = {
  shareUserListFooter: (theme: Theme) => ({
    borderTop: `1px solid ${theme.palette.grey[300]}`,
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
  }),
};
